export const getStartDate = (dateRange: string): Date => {
  const [start] = dateRange.split(' - ');
  const [day, month, year] = start.split('/');
  return new Date(`${year}-${month}-${day}`);
};

export const getEndDate = (dateRange: string): Date => {
  const [, end] = dateRange.split(' - ');
  const [day, month, year] = end.split('/');
  return new Date(`${year}-${month}-${day}`);
};
